module.exports = __webpack_public_path__ + "img/google-play-badge_zh_equalised.ad356e67.svg";